// extracted by mini-css-extract-plugin
export default {"dropzone":"Uploader_dropzone__etwmO","active":"Uploader_active__TrGB7"};